import type { ReactNode, FC, Ref } from "react";

import { Flex } from "../Flex/Flex";
import { flexStyle } from "./Columns.css";

export type ColumnsProps = {
  children: ReactNode;
  align?: "left" | "center" | "right";
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * A component that displays its children in a row with a gap between them.
 */
export const Columns: FC<ColumnsProps> = ({
  children,
  align = "center",
  ref,
}) => (
  <Flex
    ref={ref}
    gap="s"
    align={"center"}
    justify={
      align === "left"
        ? "flex-start"
        : align === "right"
          ? "flex-end"
          : "center"
    }
    className={flexStyle}
    inline
    wrap
  >
    {children}
  </Flex>
);
